import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
import { setToken, removeToken } from "@/libs/cookies";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: undefined,
    users: [],
    questions: [
      "Táo bạo-Nhiệt Huyết-Điềm tĩnh-Chính xác",
      "Có hệ thống-Kiên Nhẫn-Thích giao lưu-Quyết đoán",
      "Nhiệt huyết-Bình tâm-Tìm kiếm sự thật-Cạnh tranh",
      "Làm việc đội nhóm-Độc lập-Cạnh tranh cao-Hòa đồng",
      "Muốn ổn định-Ưa mạo hiểm-Ảnh hưởng đến người khác-Tiêu chuẩn cao",
      "Tự lực-Kiên định-Hay phân tích-Quyến rũ",
      "Thích giao lưu-Trung thành-Chấp nhận rủi ro-Tập trung cao",
      "Tận tâm-Trực tính-Ý tứ-Hòa đồng",
      "Thoải mái-Lạc quan-Đúng đắn-Quyết tâm cao",
      "Đòi hỏi khắt khe-Có sức thuyết phục-Không thích thay đổi-Thích tranh luận",
      "Bướng bỉnh-Cảm thông-Bốc đồng-Hay đòi hỏi",
      "Cảnh giác-Phiêu lưu-Hào phóng-Lịch sự",
      "Ích kỷ-Dễ thích nghi-Dễ tha thứ-Bảo thủ",
      "Ngoan cố-Tốt bụng-Tin người-Độc đoán",
      "Kiềm chế-Nổi loạn-Gan dạ-Có kỷ luật",
      "Truyền cảm hứng-Kín đáo-Dễ tuân theo-Tận tâm",
      "Táo bạo-Lạc quan-Kiên nhẫn-Kiên quyết",
      "Phân tích kỹ-Theo thông lệ-Năng nổ-Mạo hiểm",
      "Đa nghi-Nóng vội-Trầm ngâm-Khắt khe với người khác",
      "Đa cảm-Độc lập-Khiêm tốn-Thận trọng",
      "Chỉ đạo/Điều khiển người khác-Tương tác/Lôi cuốn người khác",
      "Đáp ứng/Chấp nhận người khác-Quan sát/Đánh giá người khác",
      "Chỉ đạo/Điều khiển người khác-Đáp ứng/Chấp nhận người khác",
      "Chỉ đạo/Điều khiển người khác-Quan sát/Đánh giá người khác",
      "Tương tác/Lôi cuốn người khác-Đáp ứng/Chấp nhận người khác",
      "Tương tác/Lôi cuốn người khác-Quan sát/Đánh giá người khác",
    ],
    labels: [
      {
        key: "d",
        name: "D - Chi phối",
        desc: "Có khuynh hướng thẳng thắn và thận trọng",
      },
      {
        key: "i",
        name: "I - Ảnh hưởng",
        desc: "Có khuynh hướng thẳng thắn và cởi mở",
      },
      {
        key: "s",
        name: "S - Kiên định",
        desc: "Có khuynh hướng gián tiếp và cởi mở",
      },
      {
        key: "c",
        name: "C - Tận tâm",
        desc: "Có khuynh hướng gián tiếp và thận trọng",
      },
    ],
  },
  getters: {
    user: (state) => state.user,
    users: (state) => state.users,
    questions: (state) => state.questions,
    labels: (state) => state.labels,
  },
  mutations: {
    RESET_STATE: (state) => {
      console.log("RESET_STATE");
      state.user = undefined;
      state.users = [];
    },
    SET_USER: (state, user) => {
      state.user = user;
    },
    SET_USERS: (state, users) => {
      state.users = users;
    },
    CREATED_USER: (state, user) => {
      state.users.unshift(user);
    },
    UPDATED_USER: (state, user) => {
      state.users = state.users.map((item) => {
        if (item.id === user.id) {
          return user;
        }
        return item;
      });
    },
    DELETED_USER: (state, uid) => {
      state.users = state.users.filter((item) => item.id !== uid);
    },
  },
  actions: {
    login({ commit }, authData) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: "/users/login",
          method: "post",
          data: authData,
        })
          .then((response) => {
            console.log(response);
            if (response.data.token && response.data.user) {
              commit("SET_USER", response.data.user);
              setToken(response.data.token);
              resolve();
            } else {
              reject(response.data.msg);
            }
          })
          .catch(() => {
            reject("Đăng nhập không thành công.");
          });
      });
    },
    register({ commit }, authData) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: "/users/register",
          method: "post",
          data: authData,
        })
          .then((response) => {
            console.log(response);
            if (response.data.token && response.data.user) {
              commit("SET_USER", response.data.user);
              setToken(response.data.token);
              resolve();
            } else {
              reject(response.data.msg);
            }
          })
          .catch(() => {
            reject("Đăng ký không thành công.");
          });
      });
    },
    forgot({ commit }, authData) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: "/users/forgot",
          method: "post",
          data: authData,
        })
          .then((response) => {
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              resolve(response.data);
            }
          })
          .catch(() => {
            reject("Gửi mã xác thực không thành công.");
          });
      });
    },
    changePassword({ commit }, authData) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: "/users/change_password",
          method: "put",
          data: authData,
        })
          .then((response) => {
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              resolve(response.data);
            }
          })
          .catch(() => {
            reject("Đổi mật khẩu không thành công.");
          });
      });
    },
    getActiveCode({ commit }, authData) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: "/users/get_active_code",
          method: "post",
          data: authData,
        })
          .then((response) => {
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              resolve(response.data);
            }
          })
          .catch(() => {
            reject("Gửi mã xác thực không thành công.");
          });
      });
    },
    activeAccount({ commit }, authData) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: "/users/active",
          method: "post",
          data: authData,
        })
          .then((response) => {
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              commit("SET_USER", response.data);
              resolve(response.data);
            }
          })
          .catch(() => {
            reject("Đổi mật khẩu không thành công.");
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit("RESET_STATE");
        removeToken();
        resolve();
      });
    },
    getUsers({ commit }, opts) {
      const { page, size, email } = opts;
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: "/users/admin/users",
          method: "get",
          params: {
            size,
            page,
            email,
          },
        })
          .then((response) => {
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              commit("SET_USERS", response.data);
              resolve(response.data);
            }
          })
          .catch((error) => {
            reject("Lỗi hệ thống, vui lòng thử lại sau.");
          });
      });
    },
    createUsers({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: "/users/admin/users",
          method: "post",
          data,
        })
          .then((response) => {
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              commit("CREATED_USER", response.data);
              resolve(response.data);
            }
          })
          .catch((error) => {
            reject("Lỗi hệ thống, vui lòng thử lại sau.");
          });
      });
    },
    updateUser({ commit }, opts) {
      const { uid, new_password, status } = opts;
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: `/users/admin/users/${uid}`,
          method: "put",
          params: {
            new_password,
            status,
          },
        })
          .then((response) => {
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              commit("UPDATED_USER", response.data);
              resolve();
            }
          })
          .catch((error) => {
            reject("Lỗi hệ thống, vui lòng thử lại sau.");
          });
      });
    },
    deleteUser({ commit }, uid) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: `/users/admin/users/${uid}`,
          method: "delete",
        })
          .then((response) => {
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              commit("DELETED_USER", uid);
              resolve();
            }
          })
          .catch((error) => {
            reject("Lỗi hệ thống, vui lòng thử lại sau.");
          });
      });
    },
    getCurrentUser({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: "/users/me",
          method: "get",
        })
          .then((response) => {
            console.log("get current user", response);
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              commit("SET_USER", response.data);
              resolve(response.data);
            }
          })
          .catch((error) => {
            reject("Lỗi hệ thống, vui lòng thử lại sau.");
          });
      });
    },
    getUserByID({ commit }, uid) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: `/users/by_id/${uid}`,
          method: "get",
          headers: {
            apikey: "BuiQuangHieu!((0",
          },
        })
          .then((response) => {
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              resolve(response.data);
            }
          })
          .catch((error) => {
            reject("Lỗi hệ thống, vui lòng thử lại sau.");
          });
      });
    },
    sendReport({ commit }, uid) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: `/users/send_report/${uid}`,
          method: "get",
          headers: {
            apikey: "BuiQuangHieu!((0",
          },
        })
          .then((response) => {
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              resolve(response.data);
            }
          })
          .catch((error) => {
            reject("Lỗi hệ thống, vui lòng thử lại sau.");
          });
      });
    },
    doTest({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: "/users/do_test",
          method: "post",
          data,
        })
          .then((response) => {
            if (response.data.err_code) {
              reject(response.data.msg);
            } else {
              commit("SET_USER", response.data);
              resolve(response.data);
            }
          })
          .catch((error) => {
            reject("Lỗi hệ thống, vui lòng thử lại sau.");
          });
      });
    },
  },
  modules: {},
  // plugins: [vuexLocalStorage.plugin]
  plugins: [createPersistedState()],
});
